import styled from "styled-components";

// background: rgba(135,171,152,1);
export const ServicesWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  padding-top: 50px;
  width: 100%;
  gap: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--secondary);
  border-bottom-left-radius: 10%;
  border-bottom-right-radius: 50%;
  background: var(--secondary);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
`;

export const ServiceTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 900;
  color: var(--primary);
  margin-bottom: 1rem;
  font-family: colabero;
  @media (min-width: 425px) {
    font-size: 1.5rem;
  }
`;

export const CardsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  width: 100%;
  position: relative;
  border-radius: 5px;
  padding: 25px;
  padding-bottom: 100px;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: start;
    gap: 150px;
  }
`;

export const Card = styled.div`
  display: flex;
  background: white;
  width: 87vw;
  border-radius: 15px;
  align-content: center;
  justify-content: start;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  div {
    padding: 24px;
  }

  a {
    align-self: center;
    margin-bottom: 24px;
    width: 150px;
  }
  @media (min-width: 375px) {
    a {
      width: 150px;
    }
  }
  @media (min-width: 420px) {
    a {
      width: 200px;
    }
  }

  @media (min-width: 768px) {
    width: 400px;
    a {
      width: 310px;
    }
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  border-radius: 15px;
  border-bottom-left-radius: 0;
  justify-content: center;
  background: linear-gradient(
    135deg,
    rgba(115, 93, 68, 1) 52%,
    rgba(130, 68, 39, 1) 100%
  );
  h4 {
    font-family: colabero;
    font-size: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    font-weight: 600;
    text-align: center;
    color: white;
  }
  gap: 4px;
  @media (min-width: 425px) {
    h4 {
      font-size: 13px;
    }
  }
`;

export const CardHeader2 = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  border-radius: 15px;
  border-bottom-left-radius: 0;
  background: linear-gradient(
    135deg,
    rgba(115, 93, 68, 1) 52%,
    rgba(130, 68, 39, 1) 100%
  );
  justify-content: center;
  h4 {
    font-family: colabero;
    font-size: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    font-weight: 600;
    text-align: center;
    color: white;
    width: 175px;
  }
  gap: 4px;
  @media (min-width: 425px) {
    h4 {
      font-size: 13px;
      width: 225px;
    }
  }
`;
